import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { Helmet } from 'react-helmet-async';
import { BillingsContent } from '@starjack/widgets/billings';
import { Permission } from '@/models/user';
import { PageWithLayout } from '@/models/page';

const Billings: PageWithLayout = () => {
    return (
        <>
            <Helmet>
                <title>Abrechnungen | Starjack Admin</title>
            </Helmet>

            <BillingsContent variant='admin' />
        </>
    );
};

Billings.isProtected = true;
Billings.permissions = [Permission.BILLING_NAV];
Billings.getLayout = (page) => <SidebarLayout>{page}</SidebarLayout>;

export default Billings;
